
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GalleryItem } from './pages/types/GalleryItem';
import { DUImage } from './pages/types/DUImage';

const GalleryImageCard = (props: any) => {
    const [selected, setSelected] = useState(false);
    const image: DUImage = props.image;
    const addDefaultSource = (evt: SyntheticEvent<HTMLImageElement>) => {
        if (evt.currentTarget.src === image.original) {
            return;
        }
        evt.currentTarget.src = image.original;
    }
    useEffect(() => {
        const selectedItems = props.selectedItems ? props.selectedItems.map((i: GalleryItem) => ({ ...i })) : [];
        const matched = selectedItems.filter((i: GalleryItem) => i?.image?.original === image.original && i.type === 'image');
        setSelected(matched[0]?.selected);
    }, [props.selectedItems, selected, image]);
    const handleSelected = () => {
        const newState = !selected;
        if (props.handleSelected) {
            props.handleSelected({ image, selected: newState, type: 'image' });
        }
        setSelected(newState);
    }


    const getDisplayMeta = (url: string) => {
        const parts = url.split('/');
        const fileName = parts[parts.length - 1];
        const decoded = decodeURIComponent(fileName).split('/');
        const name = decoded[decoded.length - 1];

        return (<>
            <small style={{ display: "block", textAlign: "center",position: "absolute", bottom: 0, width: "100%" }}>{name}</small>
        </>)
    };
    return <div onClick={handleSelected} className="me-2 mb-2" style={{ width: "144px", height: "144px", display: "inline-block", overflow: "hidden", position: "relative", cursor: "pointer" }}>
        {selected && <div className="p-2" style={{ position: "absolute", width: "144px", height: "144px", backgroundColor: "rgba(0,0,0,.05)", zIndex: 1 }}><FontAwesomeIcon className="text-primary" icon="check-circle" size="lg" /></div>}
        <Image onError={addDefaultSource} src={image.thumbnail} style={{ maxHeight: "140px", maxWidth: "140px", position: "absolute", top: "0", left: "0", bottom: "0", right: "0" }} className="m-auto" />
        {getDisplayMeta(image.original)}
    </div>
}
export default GalleryImageCard;
